rdefine('app/formular/models/UIFormModel',['backbone'],function(Backbone) {
    return Backbone.Ribs.Model.extend({
        defaults: {
            'name':'Default name'
        },
        initialize:function() {

        }
    });
});